import { ProviderType } from "@redotech/redo-model/integration/integration-schema-definition";
import {
  array,
  object,
  string,
  union,
  enum as zEnum,
  null as zNull,
  type infer as zInfer,
} from "zod/v4";

const providerTypeValues = [
  ProviderType.Refund,
  ProviderType.Shipping,
] as const;

export const setGlobalEIntegration = {
  name: "setGlobalEIntegration" as const,
  input: union([
    // Create new integration with credentials
    object({
      apiDomain: string(),
      username: string(),
      password: string(),
      provides: array(zEnum(providerTypeValues)).optional(),
    }),
    // Create new integration with GUID
    object({
      apiDomain: string(),
      GUID: string(),
      provides: array(zEnum(providerTypeValues)).optional(),
    }),
    // Update existing integration (only provides field)
    object({ provides: array(zEnum(providerTypeValues)).optional() }),
  ]),
  output: zNull(),
};

export type SetGlobalEIntegrationInput = zInfer<
  typeof setGlobalEIntegration.input
>;
